var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('i',{class:[ _vm.$style.iconInline, 'jc-info-circle' ]}),_c('p',[_c('MarkdownInline',{attrs:{"mdTemplate":_vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }